import { myFetch, HttpMethod } from './baseService';

// Interfaz para la solicitud de ObtenerPorUnidad
export interface GetCuotaPorUnidadRequest {
  unidad_recidencial_codigo: string;
}

// Interfaz para la solicitud de Insertar
export interface InsertCuotaRequest {
  unidad_recidencial_codigo: string;
  valor: number;
  link_Pago: string;
  Banco: string;
  cau_dia_pago: number;
}

// Interfaz para la solicitud de Modificar
export interface UpdateCuotaRequest {
  codigo: string;
  unidad_recidencial_codigo: string;
  valor: number;
  link_Pago: string;
  Banco: string;
  dia_pago: number;
}

// Interfaz para el objeto de respuesta de la cuota administrativa
export interface CuotaAdmin {
  cau_codigo: number;
  cau_unidad_residencial: string;
  cau_valor: number;
  cau_link_pago: string;
  cau_banco: string;
  cau_dia_pago: number;
}

// Interfaz genérica para la respuesta de la API
export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// Función para obtener la cuota por unidad residencial
export const getCuotaPorUnidad = async (payload: GetCuotaPorUnidadRequest) => {
  const envelope = await myFetch<ApiEnvelope<CuotaAdmin[]>>(
    'cuota_administracion_unidad/ObtenerPorUnidad',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};

// Función para insertar una nueva cuota administrativa
export const insertCuota = async (payload: InsertCuotaRequest) => {
  const envelope = await myFetch<ApiEnvelope<CuotaAdmin[]>>(
    'cuota_administracion_unidad/Insertar',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};

// Función para modificar una cuota administrativa existente
export const updateCuota = async (payload: UpdateCuotaRequest) => {
  const envelope = await myFetch<ApiEnvelope<CuotaAdmin[]>>(
    'cuota_administracion_unidad/Modificar',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};